import type cardStockId from "./id";

const cardStockEn: typeof cardStockId = {
	cardStock: {
		title: "Stock Card",
		subtitle: "Summary of stock card list",
		filter: {
			store: {
				placeholder: "Select Store",
			},
			type: {
				placeholder: "Select Type",
			},
			date: {
				placeholder: "Select Date",
			},
		},
		table: {
			title: "Stock Card Data",
			columns: {
				store: "Store",
				category: "Category",
				type: "Type",
				product: "Product",
				variant: "Variant",
				initial_stock: "Initial Stock",
				stock_in: "Stock In",
				stock_out: "Stock Out",
				sales: "Sales",
				transfer_in: "Transfer In",
				transfer_out: "Transfer Out",
				adjustment: "Adjustment",
				last_stock: "Final Stock",
				unit: "Unit",
			},
		},
		forms: {
			export: {
				toast: {
					success: {
						title: "Success",
						description: "Successfully exported {rows} rows to excel!",
					},
					failed: {
						title: "Failed",
						description: "Failed to export data to excel!",
					},
				},
			},
			delete: {
				title: "Delete Stock Card",
				description: "Are you sure you want to delete {name}?",
				toast: {
					success: {
						title: "Success",
						description: "Success to delete Stock Card!",
					},
					failed: {
						title: "Failed",
						description: "Failed to delete Stock Card!",
					},
				},
			},
		},
		empty_state: {
			title: "No stock card data",
			description: "Please add new stock card data.",
		},
		actions: {
			save: "Save",
			save_changes: "Save Changes",
			saving_changes: "Saving Changes...",
			saving: "Saving...",
			delete: "Delete",
			deleting: "Deleting...",
			cancel: "Cancel",
		},
	},
};

export default cardStockEn;
